import { TestimonialsWithMarquee } from "@/components/ui/testimonials-with-marquee";
import avatar1 from "@/assets/testimonials/avatar-1.png";
import avatar2 from "@/assets/testimonials/avatar-2.png";
import avatar3 from "@/assets/testimonials/avatar-3.png";
import avatar4 from "@/assets/testimonials/avatar-4.png";
import avatar5 from "@/assets/testimonials/avatar-5.png";
import avatar6 from "@/assets/testimonials/avatar-6.png";

const testimonials = [
  {
    author: {
      name: "Mr.Telecom",
      handle: "Founder/CEO World Mobile",
      avatar: avatar1,
      initials: "1"
    },
    text: "Revenue, revenue, revenue! that is what you should be looking for in any project. without revenue, no project has a future."
  },
  {
    author: {
      name: "Theo M.",
      handle: "Co-Founder Silencio",
      avatar: avatar2,
      initials: "2"
    },
    text: "DePIN will go mainstream because its an economic win-win-win. Contributors earn, enterprises save costs, and networks scale without capex."
  },
  {
    author: {
      name: "TheDePINCat",
      handle: "World Mobile Member",
      avatar: avatar3,
      initials: "3"
    },
    text: "DePINs will transform Infrastructure from investment and Deployment, to Innovation and customer service."
  },
  {
    author: {
      name: "Titan Network",
      handle: "DePIN Project",
      avatar: avatar4,
      initials: "4"
    },
    text: "Stop thinking of the cloud as something that only lives in massive server farms. Start thinking of it as powered by your own devices. That is the core idea behind DePIN, a new model where everyday devices route traffic, store files, and even train AI."
  },
  {
    author: {
      name: "Tindorr",
      handle: "DePIN Community Member",
      avatar: avatar5, 
      initials: "5"
    },
    text: "Attention has shifted to business with real revenue.This is why I'm so bullish on DePIN this year."
  },
  {
    author: {
      name: "Clover Nodes",
      handle: "World Mobile Member",
      avatar: avatar6,
      initials: "6"
    },
    text: "When Verizon, AT&T, and T-Mobile go dark, it exposes a fragile system. Centralized networks fail at scale. Community owned networks Don’t."
  }
];

const TestimonialsSection = () => {
  return (
    <TestimonialsWithMarquee
      title="Voice of Success"
      description="Real transforming stories across DePIN Community "
      testimonials={testimonials}
    />
  );
};

export default TestimonialsSection;
